/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BasicModel,
    BasicModelFromJSON,
    BasicModelFromJSONTyped,
    BasicModelToJSON,
} from './BasicModel';

/**
 * 
 * @export
 * @interface RenterCompanyPaymentInfoViewModel
 */
export interface RenterCompanyPaymentInfoViewModel {
    /**
     * 
     * @type {number}
     * @memberof RenterCompanyPaymentInfoViewModel
     */
    id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RenterCompanyPaymentInfoViewModel
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RenterCompanyPaymentInfoViewModel
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RenterCompanyPaymentInfoViewModel
     */
    taxIdentityNo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RenterCompanyPaymentInfoViewModel
     */
    taxOffice?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RenterCompanyPaymentInfoViewModel
     */
    taxOfficeCityId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RenterCompanyPaymentInfoViewModel
     */
    iban?: string | null;
    /**
     * 
     * @type {Array<BasicModel>}
     * @memberof RenterCompanyPaymentInfoViewModel
     */
    serviceRegions?: Array<BasicModel> | null;
}

export function RenterCompanyPaymentInfoViewModelFromJSON(json: any): RenterCompanyPaymentInfoViewModel {
    return RenterCompanyPaymentInfoViewModelFromJSONTyped(json, false);
}

export function RenterCompanyPaymentInfoViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenterCompanyPaymentInfoViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'taxIdentityNo': !exists(json, 'taxIdentityNo') ? undefined : json['taxIdentityNo'],
        'taxOffice': !exists(json, 'taxOffice') ? undefined : json['taxOffice'],
        'taxOfficeCityId': !exists(json, 'taxOfficeCityId') ? undefined : json['taxOfficeCityId'],
        'iban': !exists(json, 'iban') ? undefined : json['iban'],
        'serviceRegions': !exists(json, 'serviceRegions') ? undefined : (json['serviceRegions'] === null ? null : (json['serviceRegions'] as Array<any>).map(BasicModelFromJSON)),
    };
}

export function RenterCompanyPaymentInfoViewModelToJSON(value?: RenterCompanyPaymentInfoViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'companyName': value.companyName,
        'address': value.address,
        'taxIdentityNo': value.taxIdentityNo,
        'taxOffice': value.taxOffice,
        'taxOfficeCityId': value.taxOfficeCityId,
        'iban': value.iban,
        'serviceRegions': value.serviceRegions === undefined ? undefined : (value.serviceRegions === null ? null : (value.serviceRegions as Array<any>).map(BasicModelToJSON)),
    };
}

